import {AbstractControl, ValidatorFn} from '@angular/forms';

import {OnlyLatinValidatorKey} from './custom-validator-keys';

export function OnlyLatinValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        return !/^[a-zA-Z\s]+$/.test(controlValue) ? {[OnlyLatinValidatorKey]: true} : null;
    };
}
